module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.multiLanguage.detail) + "  (" + _vm._s(_vm.obj.IB_ID) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('el-button', {
    staticClass: "preview-btn",
    attrs: {
      "round": "",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.return))])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  }, [(_vm.trData) ? _c('mtable', {
    attrs: {
      "downLoadTran": _vm.downLoadTran,
      "jsonExcelAjax": _vm.jsonExcelAjax,
      "multiLanguage": _vm.multiLanguage,
      "name": _vm.name,
      "thData": _vm.thData,
      "trData": _vm.trData
    }
  }, [_c('div', {
    staticClass: "handleDiv",
    attrs: {
      "slot": "handle"
    },
    slot: "handle"
  }, [_c('div', {
    staticClass: "spanDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.IB_ID) + " " + _vm._s(_vm.obj.IB_ID))])]), _vm._v(" "), _c('div', {
    staticClass: "spanDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.typeText) + " " + _vm._s(_vm.obj.type))])]), _vm._v(" "), _c('div', {
    staticClass: "spanDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.deposit_order_id) + " " + _vm._s(_vm.obj.DEPOSIT_ORDER_ID))])]), _vm._v(" "), _c('div', {
    staticClass: "spanDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.start_time) + " " + _vm._s(_vm.obj.BEGINTIME))])]), _vm._v(" "), _c('div', {
    staticClass: "spanDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.end_time) + " " + _vm._s(_vm.obj.ENDTIME))])])])]) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-424474f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommissionSetting2/IB/IBResult/realTimeDetailResult.vue
// module id = 1103
// module chunks = 1